var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedPurse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53766 3.62914H6.00865V2.05643C6.00865 1.20095 6.74984 0.5 7.6657 0.5H13.3341C14.2498 0.5 14.9912 1.20072 14.9912 2.05643V3.62914H18.4621C19.8574 3.62914 21 4.69654 21 6.0004V16.1287C21 17.4324 19.8576 18.5 18.4621 18.5H2.53785C1.1426 18.5 0 17.4326 0 16.1287V6.0004C0 4.69672 1.14241 3.62914 2.53785 3.62914H2.53766ZM9.83678 7.01888H11.1623C11.4239 7.01888 11.6419 7.22255 11.6419 7.47512V10.0011H14.3453C14.6069 10.0011 14.8248 10.2048 14.8248 10.4493V11.6797C14.8248 11.9323 14.6069 12.1279 14.3453 12.1279H11.6419V14.6539C11.6419 14.9064 11.4239 15.1101 11.1623 15.1101H9.83678C9.57516 15.1101 9.3572 14.9064 9.3572 14.6539V12.1279H6.65383C6.39221 12.1279 6.17426 11.9323 6.17426 11.6797V10.4493C6.17426 10.2048 6.39221 10.0011 6.65383 10.0011H9.3572V7.47512C9.3572 7.22255 9.57516 7.01888 9.83678 7.01888ZM7.12463 3.62914H13.8749V2.25206C13.8749 2.04839 13.6918 1.87715 13.4737 1.87715H7.52603C7.30807 1.87715 7.12479 2.04822 7.12479 2.25206L7.12463 3.62914Z",
    fill: "#1C1C1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedPurse);
export default __webpack_public_path__ + "static/media/med-purse.249226dae0e2bc7f94e9495f41d42a53.svg";
export { ForwardRef as ReactComponent };